import { styled } from '@/stitches.config';
import { Box } from '@base-app';
import { ReactComponent as SquareIcon } from '@assets/icons/square-icon.svg';

export const StyledChartContainer = styled(Box, {
  padding: '$1',

  'rect:first-child': {
    fill: 'none',
    stroke: 'none',
  },

  '.recharts-brush-slide': {
    fill: '$coolGray100',
    rx: '5',
  },

  '.recharts-brush-texts': {
    display: 'none',
  },

  '.recharts-tooltip-wrapper > div': {
    transform: 'translateX(0) translateY(-20px)',
  },
});

export const StyledReferenceContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: '20px',
});

export const StyledBaselineReferenceIcon = styled(SquareIcon, {
  borderRadius: '$radii$2',
  height: '$4',
  marginRight: '$2',
  width: '$4',
});

export const StyledReferenceText = styled('span', {
  color: '$darkGray200',
  fontSize: '$xs',
  fontWeight: '$medium',
});

export const StyledBaselineValue = styled('span', {
  color: '$darkGray200',
  fontSize: '$xs',
  fontWeight: '$bold',
  marginLeft: '$1',
});
